<template>
    <div class="message-tip" v-show="show">
        <div class="tip_box">
            <div class="close" @click="show = false">
                <i class="el-icon-circle-close"></i>
            </div>
            <div class="tip_title">
                <span>{{title || '删除提示'}}</span>
            </div>
            <div class="tip_content">
                <img src="../../assets/images/tip.png" alt="">
                <span>{{msg}}</span>
            </div>
            <div class="act_box">
                <div class="button cancel" @click="show = false">
                    <span>取消</span>
                </div>
                <slot name="confirm_btn">
                    <div class="button del" @click="del">
                        <span>删除</span>
                    </div>
                </slot>
                
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tip',
    data() {
        return {
            show: false
        }
    },
    props: ['title', 'msg'],
    methods: {
        del() {
            this.show = false;
            this.$emit('tipBack');
        }
    }
}
</script>
<style scoped lang="less">
    .message-tip{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.4);
        z-index: 9999;
        .tip_box{
            width: 450px;
            padding-bottom: 30px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: @colorWhite;
            border-radius: 24px;
            .tip_title{
                padding: 20px 0 10px 20px;
                line-height: 1.3;
                font-weight: 600;
                border-bottom: 1px solid @colorLine;
            }
            .tip_content{
                padding: 40px 20px 30px;
                .flexLayout();
                flex-wrap: nowrap;
                font-size: 14px;
                img{
                    width: 24px;
                    margin-right: 10px;
                    margin-top: 4px;
                }
            }
            .act_box{
                .flexLayout();
                .button{
                    margin: 0 5px;
                    width: 118px;
                    height: 34px;
                    line-height: 34px;
                    background-color: #E8EBF2;
                    border: none;
                    &.cancel{
                        color: @color666;
                    }
                    &.del{
                        background-color: #EB534B;
                    }
                }
            }
            .close{
                position: absolute;
                top: 16px;
                right: 20px;
                font-size: 20px;
                color: @colorGray;
                cursor: pointer;
            }
            @media (max-width: 500px) {
                width: 92%;
            }
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/components/dialog/tip.vue